import moment from 'moment';

export default {
  $diffDates(from, to) {
    return moment(from).startOf('day').diff(moment(to).startOf('day'), 'days');
  },
  $isAfter(date, item) {
    return moment(item).startOf('day').diff(moment(date).startOf('day'), 'days') >= 0;
  },
  $isSame(date, item) {
    return moment(item).startOf('day').isSame(moment(date).startOf('day'));
  },
  $getDaysFromNow(count) {
    let days = count;
    const arrDays = [];
    let day = moment();

    while (days) {
      arrDays.push(day.toISOString());
      day = moment(day).subtract(1, 'days');
      days -= 1;
    }

    return arrDays;
  },
};
